import { AuthToken } from './auth-token';
export class AuthSmsAuthResponse extends AuthToken {}
